import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const Ctx = createContext({ user: null, token: null, login: async () => {}, register: async () => {}, logout: () => {}, loading: false });

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem("dv_token"));
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);

  const setHeader = useCallback((t) => {
    if (t) api.defaults.headers.common["Authorization"] = `Bearer ${t}`;
    else delete api.defaults.headers.common["Authorization"];
  }, []);

  const refreshUser = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
      localStorage.removeItem("dv_token");
      setToken(null);
      setHeader(null);
    }
  }, [setHeader]);

  useEffect(() => {
    if (token) {
      setHeader(token);
      refreshUser();
    }
  }, [token, refreshUser, setHeader]);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("dv_token", data.access_token);
      setHeader(data.access_token);
      setToken(data.access_token);
      setUser(data.user);
      return data.user;
    } finally { setLoading(false); }
  };

  const register = async (payload) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", payload);
      localStorage.setItem("dv_token", data.access_token);
      setHeader(data.access_token);
      setToken(data.access_token);
      setUser(data.user);
      return data.user;
    } finally { setLoading(false); }
  };

  const logout = () => {
    localStorage.removeItem("dv_token");
    setHeader(null);
    setToken(null);
    setUser(null);
  };

  return <Ctx.Provider value={{ user, token, login, register, logout, loading }}>{children}</Ctx.Provider>;
};

export const useAuth = () => useContext(Ctx);
